import { SVGProps } from "react";

export const IconCool = ({ width = 64, height = 64, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="#4C9DF1"
      stroke="#3F4A61"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.083}
      d="M7.01 29.788a2.36 2.36 0 0 1 .122-.988c.111-.318.29-.61.522-.857a2.49 2.49 0 0 1 .833-.58 2.55 2.55 0 0 1 1.001-.205h4.753c.66 0 1.294.255 1.76.709.467.454.73 1.07.73 1.712v23c0 .642-.263 1.258-.73 1.712-.466.454-1.1.709-1.76.709h-2.695a2.528 2.528 0 0 1-1.683-.636 2.397 2.397 0 0 1-.798-1.576l-2.056-23Zm17.188-.966c0-1.012.647-1.917 1.586-2.348 2.053-.942 5.549-2.834 7.125-5.392 2.033-3.297 2.416-9.254 2.478-10.619.009-.19.004-.382.03-.57.337-2.365 5.028.396 6.826 3.316.977 1.583 1.102 3.664 1 5.29-.111 1.738-.635 3.417-1.149 5.085l-1.095 3.556H54.51c.384 0 .764.086 1.108.253.344.166.644.408.877.706.232.299.39.645.46 1.013.072.367.055.746-.05 1.106l-6.683 23.02a2.42 2.42 0 0 1-.894 1.272c-.432.318-.96.49-1.503.49h-21.14c-.66 0-1.293-.255-1.76-.71a2.388 2.388 0 0 1-.728-1.711V28.822Z"
    />
  </svg>
);
